import { ServiceFunction } from "utils/index";
import BaseService from "../base";
import {
  GetAccountAbbrListResponseType,
  GetCoverSheetPayloadType,
  GetCoverSheetResponseType,
  GetGlobalFiltersResponseType,
  GetProcedureListFilterNewResponseType,
  GetProcedureListNewPayloadType,
  GetProcedureListNewResponseType,
  IChangeSectionLockPayload,
  ICheckSectionLockPayload,
  IGetTaskProcedurePPOInfoResponse,
  ISectionLockResponse,
} from "./types";

class ProcedureListService extends BaseService {
  getAllAccountAbbreviations = (
    para: number,
    success: (res: GetAccountAbbrListResponseType) => void,
    error: (error: any) => void
  ) => {
    // @ts-ignore
    this.sendRequest("getAllAccountAbbreviations", para, success, error);
  };

  // @ts-ignore
  getGlobalFilters = (
    props: { isActive: string } | undefined
  ): Promise<GetGlobalFiltersResponseType> => this.sendSyncRequest("getGlobalFilters", props);

  getProcedureListNew = (
    para: GetProcedureListNewPayloadType
  ): Promise<GetProcedureListNewResponseType> => {
    const { accountStatus, taskStatus, ...rest } = para;
    // @ts-ignore
    return this.sendSyncRequest("getProcedureListNew", {
      ...rest,
      ...(accountStatus !== 2 && { accountStatus }),
      ...(taskStatus !== 2 && { taskStatus }),
    });
  };

  getProcedureListFilterNew = (
    para: Pick<
      GetProcedureListNewPayloadType,
      | "accountStatus"
      | "taskStatus"
      | "accountIds"
      | "taskGroupIds"
      | "categoryIds"
      | "taskId"
      | "taskLabelName"
    >
  ): Promise<GetProcedureListFilterNewResponseType | Response> => {
    const { accountStatus, taskStatus, ...rest } = para;
    // @ts-ignore
    return this.sendSyncRequest("getProcedureListFilterNew", {
      ...rest,
      ...(accountStatus !== 2 && { accountStatus }),
      ...(taskStatus !== 2 && { taskStatus }),
    });
  };

  assignPrimaryProcedureOwner = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("assignPrimaryProcedureOwner", para, success, error);
  };

  applyPMPExcluded = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("applyPMPExcluded", para, success, error);
  };

  getProcedureDocumentList = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("getProcedureDocumentList", para, success, error);
  };

  getCoverSheet = (
    para: GetCoverSheetPayloadType,
    success: (data: GetCoverSheetResponseType) => void,
    error: any
  ) => {
    // @ts-ignore
    this.sendRequest("getCoverSheet", para, success, error);
  };

  getActiveInternalUserInfos = (success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("getActiveInternalUserInfos", {}, success, error);
  };

  shareDocument = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("shareDocument", para, success, error);
  };

  downloadCheck = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("downloadCheck", para, success, error);
  };

  checkProcedureDetailEdit = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("checkProcedureDetailEdit", para, success, error);
  };

  exportProcedureListNew = (
    para: Omit<GetProcedureListNewPayloadType, "pageIndex" | "pageSize">
  ): Promise<string> => {
    const { accountStatus, taskStatus, ...rest } = para;
    // @ts-ignore
    return this.sendSyncRequest("exportProcedureListNew", {
      ...rest,
      ...(accountStatus !== 2 && { accountStatus }),
      ...(taskStatus !== 2 && { taskStatus }),
    });
  };

  getTaskProcedurePPOInfo = (para: { procedureTaskId: string }) => {
    // @ts-ignore
    return this.sendSyncRequest(
      "getTaskProcedurePPOInfo",
      para
    ) as Promise<IGetTaskProcedurePPOInfoResponse>;
  };

  getFirstPpo = (procedureId: string, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("getFirstPpo", { procedureId }, success, error);
  };
  // check the section lock
  // @ts-ignore
  checkSectionLock = (para: ICheckSectionLockPayload) =>
    this.sendSyncRequest("checkSectionLock", para) as Promise<ISectionLockResponse>;
  // toggle the section lock
  setSectionLock = (para: IChangeSectionLockPayload) =>
    // @ts-ignore
    this.sendSyncRequest(
      "setSectionLock",
      para,
      undefined,
      undefined,
      undefined,
      undefined,
      true
    ) as Promise<{
      succeeded: boolean;
    }>;

  releaseLockOnUnload = (para: { procedureId: string; procedureSectionType: string }) => {
    this.sendBeaconRequest("releaseSectionLockOnUnload", para);
  };
}

const procedureListService = new ProcedureListService();

export default procedureListService;
